import React from "react";
import { Col } from "reactstrap";
import { FaPen } from "react-icons/fa";
import { DeviceData } from "../../store/LabEquipment";
import "./EquipmentCard.css";

type EquipmentCardProps = {
    device: DeviceData,
    onEdit: (device: DeviceData) => void;
}

const EquipmentCard = (props: EquipmentCardProps) => {
    const { device, onEdit } = props;
    return (
        <Col className="col-md-2">
            <div className={`device-card ${device.Lab_Instrument_blocked ? 'blocked' : ''}`}>
                <div className="card-header">
                    <span className="edit-trigger" onClick={() => onEdit(device)}>
                        <FaPen className="edit-icon"/>
                    </span>
                    <p className="instrument-code">{device.Lab_Instrument_code}</p>
                    <p className="instrument-status">{device.Lab_Instrument_blocked ? "Blocked" : "Active"}</p>
                </div>
            </div>
        </Col>
    );
};

export default EquipmentCard;